module.exports = __webpack_public_path__ + "img/premium-section.b12b4b8.svg";